import { render, staticRenderFns } from "./PosHeader.vue?vue&type=template&id=20ae455c&scoped=true"
import script from "./PosHeader.vue?vue&type=script&lang=js"
export * from "./PosHeader.vue?vue&type=script&lang=js"
import style0 from "./PosHeader.vue?vue&type=style&index=0&id=20ae455c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ae455c",
  null
  
)

export default component.exports